// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260130/js/" + chunkId + "." + {"44":"cdc46865","225":"50e8f465","481":"0bf34f2e","486":"894cf5ed","770":"49b9dbb9"}[chunkId] + ".0.7193035103550522.chunk.js";
};